import React, { useEffect } from 'react';
import styled from "styled-components";
import { ManageUsersSidebar } from "./components/ManageUsersSidebar";
import Layout from '@shared/ui/organisms/layout/Layout';
import { FloatingSidebar, FullScreenContent } from "@features/whereabouts/pages/company-movements/components/ViewComponents";
import { tablet } from '@shared/ui/atoms/MediaQueries';
import { ManageUsersHeader } from "./components/ManageUsersHeader";
import { ManageUsersList } from "./components/ManageUsersList";
import { useDispatch, useSelector } from "react-redux";
import { loadDetails, loadUsers } from "./ducks/manage-users.duck";
import { selectIsInTeamsApp } from "@shared/store/auth.duck";

export function ManageUsersPage(props: Props) {
  const dispatch = useDispatch();
  const isInTeamsApp = useSelector(selectIsInTeamsApp);

  useEffect(() => {
    dispatch(loadDetails());
    dispatch(loadUsers());
  }, [dispatch]);

  return (
    <Layout hideFooter={true} fullScreenView={true} hideRibbon={true}>
      <FullScreenContent>
        <Sidebar>
          <ManageUsersSidebar />
        </Sidebar>
        <ManageUsersContent isInTeams={isInTeamsApp}>
          <ManageUsersHeader />
          <ManageUsersList />
        </ManageUsersContent>
      </FullScreenContent>
    </Layout>
  )
}

interface Props {
}

const Sidebar = styled(FloatingSidebar)<any>`
  @media (${tablet}) {
  }
`

const ManageUsersContent = styled.div<any>`
  height: calc(100vh - ${props => props.isInTeams ? '0' : '60px'});
  max-height: 100%;
  max-width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 24px;
  @media (${tablet}) {
    margin-right: 300px;
    margin-left: auto;
    max-width: calc(1400px - ((2200px - (100vw - 1400px)) - 1400px) / 2);
  }
  @media (min-width: 1100px) {
    margin-right: 330px;
  }
  @media (min-width: 2000px) {
    max-width: 1300px;
  }
`
